import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    container: {
      borderRadius: 8,
      borderTop: `1px solid ${theme.gray50}`,
      display: "flex",
      rowGap: 0,
    },
    item: {
      margin: theme.spacing(4, 0),
      padding: theme.spacing(0, 8),
      borderRight: `0.5px solid ${theme.gray200}`,
    },
    noBorder: {
      borderRight: "none",
    },
    divider: {
      borderBottom: `1px solid ${theme.gray200}`,
      width: "100%",
    },
    label: {
      alignItems: "center",
      color: theme.gray500,
      display: "flex",
      fontSize: 14,
      fontWeight: 400,
      gap: theme.spacing(2),
      lineHeight: "20px",
    },
    tooltip: {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    value: {
      alignItems: "center",
      color: theme.gray800,
      display: "flex",
      fontSize: 16,
      fontWeight: 500,
      gap: theme.spacing(4),
      lineHeight: "24px",
      marginTop: theme.spacing(4),
      overflow: "hidden",
      position: "relative",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    tooltipIcon: {
      color: theme.gray500,
      height: "16px",
      marginLeft: "auto",
      width: "16px",
    },
    icon: {
      color: theme.gray500,
      cursor: "pointer",
      display: "none",
      height: "16px",
      margin: theme.spacing(0, 2),
      width: "16px",
    },
    valueText: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      flex: 1,
    },
    copied: {
      background: `linear-gradient(90deg, rgba(255, 255, 255, 0), ${theme.white00} 17.5%, ${theme.white00})`,
      color: theme.gray500,
      fontSize: 14,
      marginLeft: "auto",
      padding: theme.spacing(0, 4),
      position: "absolute",
      right: 0,
    },
    clickable: {
      cursor: "pointer !important",
      "&:hover": {
        "& svg": {
          display: "block",
        },
      },
    },
  }),
);
